import { GoogleLogin } from '@react-oauth/google';
import { Zap } from 'lucide-react';
import { useAuth } from '@/contexts';

export function LoginPage() {
  const { login, error, isLoading } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950">
      <div className="w-full max-w-sm text-center">
        {/* Logo */}
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#F78C4E]">
          <Zap className="h-8 w-8 text-white" />
        </div>

        <h1 className="text-2xl font-bold text-white">Marketing Intelligence Hub</h1>
        <p className="mt-2 text-sm text-zinc-400">Sign in to continue</p>

        {/* Error message */}
        {error && (
          <div className="mt-4 rounded-lg border border-red-500/20 bg-red-500/5 p-3 text-sm text-red-400">
            {error}
          </div>
        )}

        {/* Google Sign-In — always mounted to prevent re-initialization */}
        <div className="mt-8 flex justify-center">
          <div className="relative">
            <div className={isLoading ? 'pointer-events-none opacity-30' : ''}>
              <GoogleLogin
                onSuccess={(response) => {
                  if (response.credential) {
                    login(response.credential);
                  }
                }}
                onError={() => {}}
                theme="filled_black"
                size="large"
                width="300"
              />
            </div>
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center gap-2 text-sm text-zinc-500">
                <div className="h-5 w-5 animate-spin rounded-full border-2 border-zinc-700 border-t-[#F78C4E]" />
                Signing in...
              </div>
            )}
          </div>
        </div>

        <p className="mt-8 text-xs text-zinc-600">
          Access is invite-only. Contact your admin to get started.
        </p>
      </div>
    </div>
  );
}
